import { useState } from "react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { DropdownMenuItem } from "@/components/ui/dropdown-menu";
import { useAuth } from "@/contexts/AuthContext";
import { LogOut } from "lucide-react";

export const SignOutDialog = () => {
  const { signOut } = useAuth();
  const [open, setOpen] = useState(false);

  return (
    <>
      <DropdownMenuItem
        className="rounded-md px-2 py-1.5 gap-2 cursor-pointer text-red-600 hover:text-red-600 focus:text-red-600"
        onSelect={(event) => {
          event.preventDefault();
          setOpen(true);
        }}
      >
        <LogOut className="h-4 w-4 text-red-600" />
        <span className="text-sm">Sign out</span>
      </DropdownMenuItem>

      <AlertDialog open={open} onOpenChange={setOpen}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Sign out?</AlertDialogTitle>
            <AlertDialogDescription>
              You will be signed out of your account.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>Cancel</AlertDialogCancel>
            <AlertDialogAction
              onClick={() => {
                setOpen(false);
                signOut();
              }}
            >
              Sign out
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};
